<template>
	<div class="thumbnail-image">
		<img :src="image" alt="thumbnail-image" class="thumbnail-image__view" />
	</div>
</template>

<script>
import "./ThumbnailImage.scss";

export default {
	data() {
		return {};
	},
	name: "ThumbnailImage",
	props: {
		image: String
	},
	methods: {}
};
</script>
